import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const langSegments = ["ar", "en"];

function getLangSegment(pathname) {
  const parts = pathname.split("/").filter(Boolean);
  return langSegments.includes(parts[0]) ? parts[0] : null;
}

function getRest(pathname) {
  const parts = pathname.split("/").filter(Boolean);
  if (langSegments.includes(parts[0])) return parts.slice(1).join("/");
  return parts.join("/");
}

export default function ScrollToTop() {
  const { pathname, hash, state } = useLocation();
  const prevRef = useRef({ pathname, hash });

  useEffect(() => {
    const prev = prevRef.current;
    const prevLang = getLangSegment(prev.pathname);
    const nextLang = getLangSegment(pathname);
    const prevRest = getRest(prev.pathname);
    const nextRest = getRest(pathname);

    const isLanguageSwitch =
      (state && state.fromLanguageSwitch) ||
      (prevLang && nextLang && prevLang !== nextLang && prevRest === nextRest);

    if (hash) {
      const el = document.getElementById(hash.replace("#", ""));
      if (el) {
        el.scrollIntoView({ behavior: "auto", block: "start" });
        prevRef.current = { pathname, hash };
        return;
      }
    }

    if (!isLanguageSwitch && prev.pathname !== pathname) {
      window.scrollTo(0, 0);
    }

    prevRef.current = { pathname, hash };
  }, [pathname, hash, state]);

  return null;
}
